module.exports = __webpack_public_path__ + "static/media/image20.420acc66.png";